"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var button = {
    extraSmall: {
        height: '1.5rem',
        font: '0.6rem',
    },
    small: {
        height: '1.8rem',
        font: '0.7rem',
    },
    medium: {
        height: '2.5rem',
        font: '0.8rem',
    },
    large: {
        height: '2.8rem',
        font: '1rem',
    },
    extraLarge: {
        height: '3.1rem',
        font: '1.1rem',
    },
};
exports.default = button;
